import { DateTime } from 'luxon';

function StravaActivity ( { activity } )
{
    let dt = DateTime.fromISO ( activity.eventDateTime ).toFormat ( 'MMM dd HH:mm' );
    
    return <li>
                <p>{activity.name} on {dt}, {activity.type} for {Number ( activity.distance ).toFixed ( 1 )}km</p>
            </li>
}

export default StravaActivity;